import { autoserialize, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class RefusalReason extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  isActive: boolean;
}
